'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleSheet = {
  root: {
    backgroundColor: _colors2.default.theme,
    color: _colors2.default.white,
    fontSize: '10px',
    lineHeight: '10px',
    padding: '2px 4px',
    textAlign: 'center',
    borderRadius: '4px',
    fontWeight: 'inherit',
    border: '1px solid ' + _colors2.default.theme,
    transition: 'background .3s ease-in-out'
  },
  inverted: {
    color: _colors2.default.theme,
    backgroundColor: _colors2.default.white
  }
};

exports.default = styleSheet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/admin-badge/styles.js
// module id = 937
// module chunks = 0